/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Group_PlanInputs */

const en_us2_search_group_plan = /** @type {(inputs: Search_Group_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In your plan`)
};

const pt_br2_search_group_plan = /** @type {(inputs: Search_Group_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No seu plano`)
};

const es_419_search_group_plan = /** @type {(inputs: Search_Group_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En tu plan`)
};

const pt_pt2_search_group_plan = /** @type {(inputs: Search_Group_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No teu plano`)
};

const fr_fr2_search_group_plan = /** @type {(inputs: Search_Group_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dans ton programme`)
};

const de_de2_search_group_plan = /** @type {(inputs: Search_Group_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In deinem Plan`)
};

const it_it2_search_group_plan = /** @type {(inputs: Search_Group_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nella tua scheda`)
};

/**
* | output |
* | --- |
* | "In your plan" |
*
* @param {Search_Group_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_group_plan = /** @type {((inputs?: Search_Group_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Group_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_group_plan(inputs)
	if (locale === "es-419") return es_419_search_group_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_search_group_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_search_group_plan(inputs)
	if (locale === "de-DE") return de_de2_search_group_plan(inputs)
	if (locale === "it-IT") return it_it2_search_group_plan(inputs)
	return en_us2_search_group_plan(inputs)
});
export { search_group_plan as "search.group_plan" }